import React, { useState } from 'react';
import sedanImage from '../Assests/fleetimages/car_sedan.svg';
import etiosImage from '../Assests/fleetimages/car_etios.svg';
import suvImage from '../Assests/fleetimages/car_suv.svg';
import innovaImage from '../Assests/fleetimages/car_innova.svg';

const FleetTariffs = () => {
  const stateData = {
    'Odisha': {
      sedan: { oneway: 14, roundtrip: 13 },
      etios: { oneway: 15, roundtrip: 14 },
      suv: { oneway: 19, roundtrip: 18 },
      innova: { oneway: 20, roundtrip: 19 }
    },
    'Tamil Nadu': {
      sedan: { oneway: 14, roundtrip: 13 },
      etios: { oneway: 15, roundtrip: 14 },
      suv: { oneway: 19, roundtrip: 18 },
      innova: { oneway: 20, roundtrip: 19 }
    },
    'Kerala': {
      sedan: { oneway: 16, roundtrip: 15 },
      etios: { oneway: 17, roundtrip: 16 },
      suv: { oneway: 21, roundtrip: 20 },
      innova: { oneway: 22, roundtrip: 21 }
    },
    'Karnataka': {
      sedan: { oneway: 15, roundtrip: 14 },
      etios: { oneway: 16, roundtrip: 15 },
      suv: { oneway: 20, roundtrip: 19 },
      innova: { oneway: 21, roundtrip: 20 }
    },
    'Andra Pradesh': {
      sedan: { oneway: 13, roundtrip: 12 },
      etios: { oneway: 14, roundtrip: 13 },
      suv: { oneway: 18, roundtrip: 17 },
      innova: { oneway: 19, roundtrip: 18 }
    }
  };

  const [selectedState, setSelectedState] = useState('Odisha');

  const states = [
    { key: 'Odisha', label: 'Odisha' },
    { key: 'Tamil Nadu', label: 'Tamil Nadu' },
    { key: 'Kerala', label: 'Kerala' },
    { key: 'Karnataka', label: 'KA' },
    { key: 'Andra Pradesh', label: 'AP' },
  ];

  const cars = [
    {
      id: 'sedan',
      name: 'Dzire',
      seats: '4 seater',
      image: sedanImage,
      alt: 'Dzire Car'
    },
    {
      id: 'etios',
      name: 'Etios',
      seats: '4 seater',
      image: etiosImage,
      alt: 'Etios Car'
    },
    {
      id: 'suv',
      name: 'Any SUV',
      seats: '7 seater',
      image: suvImage,
      alt: 'SUV Car'
    },
    {
      id: 'innova',
      name: 'Innova',
      seats: '7 seater',
      image: innovaImage,
      alt: 'Innova Car'
    }
  ];

  return (
    <>
      {/* ─────────────────────────── DESKTOP UI (md and above) ─────────────────────────── */}
      <div className="hidden md:block font-sans p-4 md:p-6 max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="mb-6 text-center">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">Fleets & Tariffs</h1>
          <p className="text-gray-600 text-sm md:text-base mb-4">
            All rates sourced from state driver associations.
          </p>

          {/* States Tabs */}
          <div className="mb-4">
            <div className="flex flex-wrap gap-4 md:gap-6 justify-center">
              {states.map((state) => (
                <button
                  key={state.key}
                  onClick={() => setSelectedState(state.key)}
                  className={`px-4 md:px-5 py-2 md:py-2.5 text-sm md:text-base rounded-lg transition-colors ${
                    selectedState === state.key
                      ? 'bg-[#E31837] text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {state.key}
                </button>
              ))}
            </div>
          </div>

          {/* Distance Info */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 md:p-4 mb-5">
            <p className="text-sm md:text-base text-gray-800 font-medium">
              One way min: 130 km | Round trip min: 250 km
            </p>
          </div>
        </div>

        {/* Cars Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-8">
          {cars.map((car) => {
            const prices = stateData[selectedState][car.id];
            return (
              <div key={car.id} className="border border-gray-200 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="p-3 md:p-4 bg-gray-50 border-b border-gray-200">
                  <h3 className="font-bold text-gray-900 text-lg md:text-xl">{car.name}</h3>
                </div>
                <div className="p-3 md:p-4 flex justify-center items-center bg-white h-40 md:h-48">
                  <img src={car.image} alt={car.alt} className="max-h-32 md:max-h-40 max-w-full object-contain" />
                </div>
                <div className="p-3 md:p-4 border-b border-gray-200 bg-gray-50">
                  <p className="text-sm md:text-base font-medium text-gray-700">{car.seats} + Driver</p>
                </div>
                <div className="p-3 md:p-4">
                  <div className="grid grid-cols-2 gap-3 md:gap-4">
                    <div className="text-center p-3 md:p-4 bg-red-50 rounded-lg">
                      <div className="text-sm md:text-base text-gray-900 mb-1">Oneway</div>
                      <div className="text-xl md:text-2xl font-bold text-gray-900">
                        ₹{prices.oneway}<span className="text-sm md:text-base font-normal">/km</span>
                      </div>
                    </div>
                    <div className="text-center p-3 md:p-4 bg-green-50 rounded-lg">
                      <div className="text-sm md:text-base text-gray-600 mb-1">Round</div>
                      <div className="text-xl md:text-2xl font-bold text-gray-900">
                        ₹{prices.roundtrip}<span className="text-sm md:text-base font-normal">/km</span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 md:mt-4 text-center">
                    <p className="text-sm md:text-base text-gray-500">
                      <span className="font-medium">{selectedState}</span> rates
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="p-3 md:p-4 bg-blue-50 border border-blue-100 rounded-xl text-center">
          <p className="text-sm md:text-base text-gray-700">
            Showing: <span className="font-bold text-red-500">{selectedState}</span> |{' '}
            <span className="text-gray-500 ml-2">Click state tabs above to change</span>
          </p>
        </div>
      </div>

      {/* ─────────────────────────── MOBILE UI (below md) ─────────────────────────── */}
      <div className="md:hidden font-sans bg-gray-100 min-h-screen pb-6">

        {/* State Tabs — pill style like the image */}
        <div>
             <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">Fleets & Tariffs</h1>
          <p className="text-gray-600 text-sm md:text-base mb-4">
            All rates sourced from state driver associations.
          </p>
        </div>
        <div className="bg-gray-100 px-4 pt-4 pb-3 shadow-sm">
          <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
            {states.map((state) => (
              <button
                key={state.key}
                onClick={() => setSelectedState(state.key)}
                className={`flex-shrink-0 px-5 py-2 rounded-full text-sm font-semibold transition-colors ${
                  selectedState === state.key
                    ? 'bg-[#E31837] text-white'
                    : 'bg-gray-100 text-gray-500'
                }`}
              >
                {state.label}
              </button>
            ))}
          </div>
        </div>

        {/* Source note */}
        <div className="px-4 py-3">
          <p className="text-xs text-gray-900 text-center leading-snug">
            All listed rates are sourced directly from the respective state's driver association.
          </p>
        </div>

        {/* Distance Info */}
        <div className="mx-4 mb-4 bg-white rounded-xl px-4 py-3 shadow-sm">
          <div className="flex justify-between text-sm text-gray-800">
            <span>One way minimum distance</span>
            <span className="font-bold">130 km</span>
          </div>
          <div className="flex justify-between text-sm text-gray-800 mt-2">
            <span>Round Trip per day min distance</span>
            <span className="font-bold">250 km</span>
          </div>
        </div>

        {/* Car Cards */}
        <div className="flex flex-col gap-4 px-4">
          {cars.map((car) => {
            const prices = stateData[selectedState][car.id];
            return (
              <div key={car.id} className="bg-white rounded-2xl shadow-sm overflow-hidden">
                <div className="flex items-center p-4">
                  {/* Car image — left side */}
                  <div className="w-36 flex-shrink-0 flex items-center justify-center">
                    <img
                      src={car.image}
                      alt={car.alt}
                      className="w-full h-20 object-contain"
                    />
                  </div>

                  {/* Right side */}
                  <div className="flex-1 pl-3">
                    {/* Name + seater badge */}
                    <div className="mb-1">
                      <h3 className="font-bold text-gray-900 text-base leading-tight">{car.name}</h3>
                      <span className="inline-block mt-1 px-2 py-0.5 bg-gray-100 text-gray-500 text-xs rounded-md">
                        {car.seats}
                      </span>
                    </div>

                    {/* Pricing row */}
                    <div className="flex gap-4 mt-2">
                      {/* One way */}
                      <div>
                        <div className="flex items-center gap-1 text-xs text-gray-500 mb-0.5">
                          <svg className="w-3 h-3 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 10l7-7m0 0l7 7m-7-7v18" />
                          </svg>
                          One way
                        </div>
                        <div className="text-lg font-bold text-gray-900">
                          ₹{prices.oneway}
                          <span className="text-xs font-normal text-gray-500">/km</span>
                        </div>
                      </div>

                      {/* Round Trip */}
                      <div>
                        <div className="flex items-center gap-1 text-xs text-gray-500 mb-0.5">
                          <svg className="w-3 h-3 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                          </svg>
                          Round Trip
                        </div>
                        <div className="text-lg font-bold text-gray-900">
                          ₹{prices.roundtrip}
                          <span className="text-xs font-normal text-gray-500">/km</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Utility style for hiding scrollbar */}
      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </>
  );
};

export default FleetTariffs;